export enum Position {
  Top = 'top',
  Bottom = 'bottom'
}
